export const toggleHeader = (state) => {
  return {
    type: 'TOGGLE_HEADER',
    scrolled: state
  }
}